
seedWebServices.service('CommentsService', ['$resource', '$http', '$cacheFactory', function ($resource, $http, $cacheFactory) {

    var serviceCache = $cacheFactory('Comments');
    var URL = '../API/CommentsApi/'

    this.list = function (orderId, screen) {
        var cache = serviceCache;
        return $http.get(URL, {
            params: { orderId: orderId, screen: screen },
            cache: cache
        });
    };

    this.getUser = function () {
        var cache = serviceCache;
        return $http.get(URL, {
            params: {},
            cache: cache
        });
    };

    this.resetCache = function () {
        serviceCache.removeAll();
    };

    this.orderId = -1;

    this.setOrderId = function (id) {
        this.orderId = id;
    };

    this.addNew = function (comment) {
        return $http.post(URL, comment);
    };	

}]);
